export const socketUrl = "https://vi-neo.oriserve.com/liveConversations"
export const networkCheckUrl = "https://google.com/"
export const botTriggeredTrackingUrl = "" //"https://brand-base-url.com/botTriggerLogging"
export const brandName = "vodafone"
export const botName = "vodafone"
export const role = "user"
export const version = 1.1
export const senderId = "neo-web-bot"
export const ga4MeasurementId = "ENTER_GA4_MEASUREMENT_ID"
export const amplitudeTrackingId = "ENTER_AMPLITUDE_KEY"
export const sentryDSN = ""
export const downloadChatlogUrl = ""//https://flynas-dev.oriserve.com/downloadChatHistory
